import { jsxs, jsx } from 'react/jsx-runtime';
import { a as EGDSIcon } from '../icon/index-chunk.esm.js';
import { c as classNames, l as liveAnnounce, L as Level } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-pill.css';
import { useLocalization } from '@shared-ui/localization-context';
import { a as analyticsTracker } from '../analytics-tracker/index-chunk.esm.js';

const getClassNameList$3 = classNames.bind(styles);
const EGDSTriggerPill = (props) => {
    const { active, children, className, disabled, icon, id, name, onClick, selected, toggleState, domRef } = props;
    const baseClassName = 'uitk-pill';
    const buttonClassName = getClassNameList$3(`${baseClassName} ${baseClassName}-content`, className, {
        [`${baseClassName}-trigger-toggle-state`]: toggleState,
        [`${baseClassName}-active`]: active,
        [`${baseClassName}-disabled`]: disabled,
        [`${baseClassName}-selected`]: selected,
    });
    return (jsxs("button", { id: id, name: name, type: "button", onClick: onClick, disabled: disabled, className: buttonClassName, "aria-expanded": toggleState, ref: domRef, children: [icon && jsx(EGDSIcon, { className: getClassNameList$3(`${baseClassName}-icon`), name: icon }), jsx("span", { className: getClassNameList$3(`${baseClassName}-text`), children: children }), jsx(EGDSIcon, { name: "expand_more", className: getClassNameList$3(`${baseClassName}-trigger-icon`) })] }));
};
EGDSTriggerPill.displayName = 'EGDSTriggerPill';

const getClassNameList$2 = classNames.bind(styles);
const EGDSPill = (props) => {
    const { active, altText, children, checked, className, disabled, icon, id, name, onChange, onClick, selected, triggerPill, toggleState, value, domRef, } = props;
    const triggerPillProps = {
        active,
        children,
        className,
        disabled,
        icon,
        id,
        name,
        onClick,
        selected,
        toggleState,
        domRef,
    };
    const baseClassName = 'uitk-pill';
    const wrapperClassName = getClassNameList$2(baseClassName, className, {
        [`${baseClassName}-disabled`]: disabled,
    });
    const pillContentClassName = getClassNameList$2(`${baseClassName}-content`, {
        [`${baseClassName}-active`]: active,
        [`${baseClassName}-selected`]: selected,
    });
    const inputValue = value ?? `${checked}`;
    return triggerPill ? (jsx(EGDSTriggerPill, { ...triggerPillProps })) : (jsxs("div", { className: wrapperClassName, children: [jsx("input", { id: id, name: name, checked: checked, type: "checkbox", onChange: onChange, className: getClassNameList$2(`${baseClassName}-standard is-visually-hidden`), disabled: disabled, value: inputValue }), jsxs("label", { className: pillContentClassName, htmlFor: id, "aria-label": altText, children: [icon && jsx(EGDSIcon, { className: getClassNameList$2(`${baseClassName}-icon`), name: icon }), jsx("span", { className: getClassNameList$2(`${baseClassName}-text`), children: children })] })] }));
};
EGDSPill.defaultProps = {
    checked: false,
};
EGDSPill.displayName = 'EGDSPill';

const getClassNameList$1 = classNames.bind(styles);
const EGDSRemovablePill = (props) => {
    const { active, a11yRemoveText, altText, analytics, children, className, disabled, icon, id, name, onClick, buttonRef, value, } = props;
    const baseClassName = 'uitk-pill';
    const l10n = useLocalization();
    const handleClick = (evt) => {
        if (a11yRemoveText) {
            liveAnnounce(a11yRemoveText, Level.POLITE);
        }
        onClick(evt);
    };
    const wrapperClassName = getClassNameList$1(`${baseClassName} ${baseClassName}-removable ${baseClassName}-content`, className, {
        [`${baseClassName}-disabled`]: disabled,
        [`${baseClassName}-active`]: active,
    });
    let ariaLabel = '';
    if (altText) {
        ariaLabel = altText;
    }
    else {
        ariaLabel = `${l10n.formatText('remove')} ${children}`;
    }
    return (jsxs("button", { id: id, name: name, onClick: handleClick, onClickCapture: analytics && analyticsTracker.bind(undefined, analytics), className: wrapperClassName, type: "button", disabled: disabled, "aria-label": ariaLabel, ref: buttonRef, value: value, children: [icon && jsx(EGDSIcon, { className: getClassNameList$1(`${baseClassName}-icon`), name: icon }), jsx("span", { className: getClassNameList$1(`${baseClassName}-text`), children: children }), jsx(EGDSIcon, { className: getClassNameList$1(`${baseClassName}-action-icon`), name: "close" })] }));
};
EGDSRemovablePill.displayName = 'EGDSRemovablePill';

/* PillContainer alignment */
/** ******************* */
// Later on start and end will be added as well
const EGDSPillContainerAlignmentMap = [['center', 'uitk-pill-container-align-center']];
const EGDSPillContainerAlignments = new Map(EGDSPillContainerAlignmentMap);

const getClassNameList = classNames.bind(styles);
const EGDSPillContainer = (props) => {
    const { children, className, wrap, align, dataTestId } = props;
    const baseClassName = 'uitk-pill-container';
    const wrapperClassName = getClassNameList(baseClassName, className, align && EGDSPillContainerAlignments.get(align), {
        [`${baseClassName}-wrap`]: wrap,
    });
    return (jsx("div", { className: wrapperClassName, "data-stid": dataTestId, children: children }));
};
EGDSPillContainer.displayName = 'EGDSPillContainer';

export { EGDSPill as E, EGDSRemovablePill as a, EGDSTriggerPill as b, EGDSPillContainer as c };
//# sourceMappingURL=index-chunk.esm.js.map
